import {
  GET_ALL_CERTIFICATIONS,
  GET_ALL_CERTIFICATION_FOR_ENTITY,
  GET_CERTIFICATION,
  CREATE_CERTIFICATION,
  UPDATE_CERTIFICATION,
  DELETE_CERTIFICATION,
  GET_CERTIFICATION_CUSTOM_FIELD_TEMPLATE,
  UPDATE_CERTIFICATION_CUSTOM_FIELD_TEMPLATE,
  GET_CERTIFICATION_CUSTOM_DATA,
  GET_CERTIFICATION_TYPES,
} from '../../state/actionTypes';

const ENTITY_ID_KEY_MAP = {
  users: 'userId',
  vendors: 'vendorId',
  equipment: 'equipmentId',
};

const updateCompanyCertifications = (
  companyCertifications,
  certifications,
  entityType,
  entityId,
) => {
  const idKey = ENTITY_ID_KEY_MAP[entityType] ?? 'userId';
  const entityCertifications = certifications.filter((cert) => cert[idKey] === entityId);
  return companyCertifications.filter(
    (cert) => cert[idKey] !== entityId,
  ).concat(entityCertifications);
};

const initialState = {
  users: {
    certifications: [],
    certificationTypes: [],
    selectedCertification: null,
    companyCertifications: [],
    certificationCustomFieldTemplate: {
      fields: [], sections: [],
    },
    certificationCustomData: [],
    certificationCustomDataFiles: {},
  },
  vendors: {
    certifications: [],
    certificationTypes: [],
    selectedCertification: null,
    companyCertifications: [],
    certificationCustomFieldTemplate: {
      fields: [], sections: [],
    },
    certificationCustomData: [],
    certificationCustomDataFiles: {},
  },
  equipment: {
    certifications: [],
    certificationTypes: [],
    selectedCertification: null,
    companyCertifications: [],
    certificationCustomFieldTemplate: {
      fields: [], sections: [],
    },
    certificationCustomData: [],
    certificationCustomDataFiles: {},
  },
};

export default function certificationActions(state = initialState, action = {}) {
  const { entityType } = action?.payload ?? {};
  switch (action.type) {
    case GET_ALL_CERTIFICATIONS: {
      return {
        ...state,
        [entityType]: {
          ...state[entityType] ?? {},
          companyCertifications: action.payload.data,
        },
      };
    }
    case GET_ALL_CERTIFICATION_FOR_ENTITY: {
      return {
        ...state,
        [entityType]: {
          ...state[entityType] ?? {},
          certifications: action.payload.data,
        },
      };
    }
    case GET_CERTIFICATION: {
      return {
        ...state,
        [entityType]: {
          ...state[entityType] ?? {},
          selectedCertification: action.payload.data?.[0],
        },
      };
    }
    case CREATE_CERTIFICATION:
    case UPDATE_CERTIFICATION: {
      const {
        [entityType]: {
          companyCertifications = [],
        } = {},
      } = state;

      const {
        payload: {
          certifications = [],
          addedTypes = [],
          entityId,
        },
      } = action;

      const newCompanyCertifications = updateCompanyCertifications(
        companyCertifications,
        certifications,
        entityType,
        entityId,
      );

      const oldCertificationTypes = state[entityType]?.certificationTypes ?? [];
      const newCertificationTypes = oldCertificationTypes.concat(addedTypes);

      return {
        ...state,
        [entityType]: {
          ...state[entityType] ?? {},
          certificationTypes: newCertificationTypes,
          certifications,
          companyCertifications: newCompanyCertifications,
          selectedCertification: null,
        },
      };
    }
    case DELETE_CERTIFICATION: {
      const {
        [entityType]: {
          companyCertifications = [],
        } = {},
      } = state;

      const {
        payload: {
          certifications = [],
          entityId,
        },
      } = action;

      const newCompanyCertifications = updateCompanyCertifications(
        companyCertifications,
        certifications,
        entityType,
        entityId,
      );

      return {
        ...state,
        [entityType]: {
          ...state[entityType] ?? {},
          certifications,
          companyCertifications: newCompanyCertifications,
          selectedCertification: null,
        },
      };
    }
    case GET_CERTIFICATION_CUSTOM_FIELD_TEMPLATE:
    case UPDATE_CERTIFICATION_CUSTOM_FIELD_TEMPLATE: {
      const {
        payload: {
          template = {},
        } = {},
      } = action;
      return {
        ...state,
        [entityType]: {
          ...state[entityType] ?? {},
          certificationCustomFieldTemplate: template,
        },
      };
    }
    case GET_CERTIFICATION_TYPES: {
      return {
        ...state,
        [entityType]: {
          ...state[entityType] ?? {},
          certificationTypes: action.payload.data,
        },
      };
    }
    case GET_CERTIFICATION_CUSTOM_DATA: {
      const {
        data: {
          data = [],
          fileMap = {},
        } = {},
      } = action.payload;
      return {
        ...state,
        [entityType]: {
          ...state[entityType] ?? {},
          certificationCustomData: data,
          certificationCustomDataFiles: fileMap,
        },
      };
    }
    default:
      return state;
  }
}
